import React from 'react';
import { View } from 'react-native';
import { Button } from 'react-native-elements';
import { useTranslation } from 'react-i18next';
import { styles } from 'styles/components/floatingVenueSelectorButtons';
import { greenColor } from 'styles/global';
import useChangeVenue from 'hooks/useChangeVenue';
import AppContext from 'contexts/AppContext';
import FloatingVenueSelectorButtonsProps from 'types/components/FloatingVenueSelectorButtonsProps';

export default ({ navigation, listReachedItsEnd }: FloatingVenueSelectorButtonsProps): JSX.Element => {
  const { t } = useTranslation();
  const { setIsLoading, setShowVenues, currentVenue, setWasVenueSelectedManually, setVenueLoad } =
    React.useContext(AppContext);
  const { storeCurrentVenue, deleteCurrentVenue, selectedVenue } = useChangeVenue();

  return (
    <View style={[styles.buttonsContainer, listReachedItsEnd && { position: 'relative' }]}>
      <Button
        title={t('confirm-venue')}
        type="clear"
        buttonStyle={styles.confirmVenueBtn}
        titleStyle={[styles.confirmVenueBtnText, { color: currentVenue?.appColor ?? greenColor }]}
        onPress={async () => {
          if (selectedVenue) {
            setIsLoading(true);
            try {
              navigation.setParams({ venueCode: selectedVenue.code });
              setWasVenueSelectedManually(true);
              await storeCurrentVenue(selectedVenue, false);
              setVenueLoad(true);
            } catch (error) {
              console.log(error);
            } finally {
              setShowVenues(false);
            }
            setIsLoading(false);
          }
        }}
        disabled={!selectedVenue}
        disabledTitleStyle={[styles.confirmVenueBtnText, { color: currentVenue?.appColor ?? greenColor }]}
        disabledStyle={styles.btnDisabled}
      ></Button>
      <Button
        title={t('choose-venue-later')}
        titleStyle={{ fontSize: 16, color: currentVenue ? '#FFF' : greenColor }}
        containerStyle={styles.selectLaterBtn}
        type="clear"
        onPress={() => {
          deleteCurrentVenue().finally(() => {
            setShowVenues(false);
          });
        }}
      ></Button>
    </View>
  );
};
